import React from 'react';

const BankCardIcon = ({size = 24}) => (
  <svg width={size} height={size} role="presentation" viewBox="0 0 16 16">
    <path
      fill={'currentColor'}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4a2 2 0 012-2h12a2 2 0 012 2H0zm0 2v6a2 2 0 002 2h12a2 2 0 002-2V6H0zm3 5a1 1 0 011-1h1a1 1 0 110 2H4a1 1 0 01-1-1z"
    />
  </svg>
)
;

export default BankCardIcon;
